import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _wrapNativeSuper from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable no-continue */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
var errorClasses = {};
var deserializers = {};
export var addCustomErrorDeserializer = function addCustomErrorDeserializer(name, deserializer) {
  deserializers[name] = deserializer;
};
export var createCustomErrorClass = function createCustomErrorClass(name) {
  var CustomErrorClass = /*#__PURE__*/function (_Error) {
    _inherits(CustomErrorClass, _Error);
    var _super = _createSuper(CustomErrorClass);
    function CustomErrorClass(message, fields, options) {
      var _this;
      _classCallCheck(this, CustomErrorClass);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      _this = _super.call(this, message || name, options);
      // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
      Object.setPrototypeOf(_assertThisInitialized(_this), CustomErrorClass.prototype);
      _this.name = name;
      if (fields) {
        for (var k in fields) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          _this[k] = fields[k];
        }
      }
      if (options && isObject(options) && "cause" in options && !("cause" in _assertThisInitialized(_this))) {
        // .cause was specified but the superconstructor
        // did not create an instance property.
        var cause = options.cause;
        _this.cause = cause;
        if ("stack" in cause) {
          _this.stack = _this.stack + "\nCAUSE: " + cause.stack;
        }
      }
      return _this;
    }
    return _createClass(CustomErrorClass);
  }( /*#__PURE__*/_wrapNativeSuper(Error));
  errorClasses[name] = CustomErrorClass;
  return CustomErrorClass;
};
function isObject(value) {
  return typeof value === "object";
}
// inspired from https://github.com/programble/errio/blob/master/index.js
export var deserializeError = function deserializeError(object) {
  if (object && typeof object === "object") {
    try {
      if (typeof object.message === "string") {
        var msg = JSON.parse(object.message);
        if (msg.message && msg.name) {
          object = msg;
        }
      }
    } catch (e) {
      // nothing
    }
    var error;
    if (typeof object.name === "string") {
      var _object = object,
        name = _object.name;
      var des = deserializers[name];
      if (des) {
        error = des(object);
      } else {
        var _constructor = name === "Error" ? Error : errorClasses[name];
        if (!_constructor) {
          console.warn("deserializing an unknown class '" + name + "'");
          _constructor = createCustomErrorClass(name);
        }
        error = Object.create(_constructor.prototype);
        try {
          for (var prop in object) {
            if (object.hasOwnProperty(prop)) {
              error[prop] = object[prop];
            }
          }
        } catch (e) {
          // sometimes setting a property can fail (e.g. .name)
        }
      }
    } else {
      if (typeof object.message === "string") {
        error = new Error(object.message);
      }
    }
    if (error && !error.stack && Error.captureStackTrace) {
      Error.captureStackTrace(error, deserializeError);
    }
    return error;
  }
  return new Error(String(object));
};
// inspired from https://github.com/sindresorhus/serialize-error/blob/master/index.js
export var serializeError = function serializeError(value) {
  if (!value) return value;
  if (typeof value === "object") {
    return destroyCircular(value, []);
  }
  if (typeof value === "function") {
    return "[Function: ".concat(value.name || "anonymous", "]");
  }
  return value;
};
// https://www.npmjs.com/package/destroy-circular
function destroyCircular(from, seen) {
  var to = {};
  seen.push(from);
  for (var _i = 0, _Object$keys = Object.keys(from); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    var value = from[key];
    if (typeof value === "function") {
      continue;
    }
    if (!value || typeof value !== "object") {
      to[key] = value;
      continue;
    }
    if (seen.indexOf(from[key]) === -1) {
      to[key] = destroyCircular(from[key], seen.slice(0));
      continue;
    }
    to[key] = "[Circular]";
  }
  if (typeof from.name === "string") {
    to.name = from.name;
  }
  if (typeof from.message === "string") {
    to.message = from.message;
  }
  if (typeof from.stack === "string") {
    to.stack = from.stack;
  }
  return to;
}